import * as api from "Api";
import * as actions from "Actions";

export const fetchErpData = () => {
  return (dispatch, getState) => {
    const { id } = getState().auth.currentOrganization;
    const { client, collaborator } = getState().erpData.filter;
    return dispatch(
      actions.fetchErpData(
        api.getErpData(id, client.selected, collaborator.selected)
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/erp-data.js